<template>
  <div class="container-fluid py-4 roles-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-shield-lock fs-2 text-success"></i>
        <h2 class="fw-bold mb-0">Rôles</h2>
      </div>

      <button
        class="btn btn-success btn-lg shadow-sm btn-boutique mt-2 mt-md-0"
        @click="creation"
        v-if="$store.getters.hasPermission('ROLE_CREATE')"
      >
        <i class="bi bi-plus-circle me-1"></i>
      </button>

    </div>

    <!-- ================= FILTRES ================= -->
    <div class="card shadow-sm rounded card-boutique p-3 mb-4">

      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Nom du rôle..."
            class="form-control form-control-boutique"
          />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items</label>
          <select v-model="itemsperpage" class="form-select form-select-boutique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-boutique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">
              {{ key }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-boutique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">
              {{ key }}
            </option>
          </select>
        </div>

      </div>
    </div>

    <!-- ================= LOADING ================= -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-success" style="width:4rem;height:4rem;"></div>
      <p class="mt-3">Chargement...</p>
    </div>

    <!-- ================= TABLE ================= -->
    <div v-else class="card shadow-sm rounded card-boutique">

      <div class="table-responsive">

        <table class="table table-hover text-center align-middle modern-table-boutique mb-0">

          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="(type, index) in paginatedTypeUsers" :key="type.id">

              <td>
                {{ index + 1 + (currentPage - 1) * itemsperpage }}
              </td>

              <td class="fw-semibold text-start">
                {{ type.nom }}
              </td>

              <td>
                <span :class="type.isEnabled ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ type.isEnabled ? 'Actif' : 'Inactif' }}
                </span>
              </td>

              <td>

                <div class="dropdown">

                  <button class="btn btn-sm btn-outline-success dropdown-toggle" data-bs-toggle="dropdown">
                    Actions
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end">

                    <li v-if="$store.getters.hasPermission('ROLE_UPDATE')">
                      <a class="dropdown-item" @click="modifier(type.id)">
                        Modifier
                      </a>
                    </li>

                    <li v-if="$store.getters.hasPermission('ROLE_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(type.id)">
                        Supprimer
                      </a>
                    </li>

                  </ul>

                </div>

              </td>

            </tr>

            <tr v-if="paginatedTypeUsers.length === 0">
              <td colspan="4" class="text-center py-4">
                Aucun rôle trouvé
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <!-- ================= PAGINATION ================= -->
      <div class="d-flex justify-content-end p-3">

        <ul class="pagination pagination-boutique mb-0">

          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              Précédent
            </button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              Suivant
            </button>
          </li>

        </ul>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'

export default {

  data() {
    return {

      isLoading: true,

      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'nom',
      sortOrder: 'asc',

      typeUsers: [],
      currentPage: 1,

      itemsPerPageT: [10, 20, 50],

      orderByTabs: {
        Nom: 'nom',
        Création: 'createdAt',
        Modification: 'updatedAt'
      },

      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc'
      }

    }
  },

  computed: {

    // ================= FILTER + SORT =================
    processedData() {

      let data = [...this.typeUsers]

      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase()
        data = data.filter(t =>
          (t.nom || '').toLowerCase().includes(q)
        )
      }

      data.sort((a, b) => {

        let valA = a[this.orderBy]
        let valB = b[this.orderBy]

        if (this.orderBy.includes('createdAt') || this.orderBy.includes('updatedAt')) {
          valA = new Date(valA)
          valB = new Date(valB)
        }

        if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1
        if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1
        return 0
      })

      return data
    },

    // ================= PAGINATION =================
    paginatedTypeUsers() {

      const start = (this.currentPage - 1) * this.itemsperpage
      const end = start + this.itemsperpage

      return this.processedData.slice(start, end)
    },

    totalPages() {
      return Math.ceil(this.processedData.length / this.itemsperpage) || 1
    }

  },

  methods: {

    creation() {
      this.$router.push({ name: 'create_type_users' })
    },

    modifier(id) {
      this.$router.push({ name: 'edit_type_users', params: { id } })
    },

    async getTypeUsers() {

      this.isLoading = true

      try {
        const res = await api.getItems('type_users')
        this.typeUsers = res.data.data
      } finally {
        this.isLoading = false
      }

    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },

    async supprimer(id) {

      if (!confirm("Voulez-vous supprimer ce rôle ?")) return

      await api.deleteItem('type_users', id)

      this.getTypeUsers()
    }

  },

  watch: {
    searchQuery() { this.currentPage = 1 },
    itemsperpage() { this.currentPage = 1 },
    orderBy() { this.currentPage = 1 },
    sortOrder() { this.currentPage = 1 }
  },

  created() {
    this.getTypeUsers()
  }

}
</script>

<style scoped>

.roles-page {
  background: #f5f7fb;
  min-height: 100vh;
}

.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

.card-boutique {
  border: none;
  border-radius: 20px;
  background: white;
}

.form-control-boutique,
.form-select-boutique {
  border-radius: 12px;
  border: 1px solid #dbe3ec;
}

.modern-table-boutique thead {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
}

.pagination-boutique .page-item.active .page-link {
  background: #10b981;
  color: white;
  border: none;
}

.pagination-boutique .page-link {
  border-radius: 10px;
}

.btn-boutique {
  border-radius: 12px;
}

</style>